module.exports = __webpack_public_path__ + "img/del.1b9149d6.svg";